$(document).ready(function() {
  $(".accordion .card-header").on("click", function() {
    $(this)
      .parent()
      .parent()
      .find(".card-header.active")
      .not(this)
      .removeClass("active");
    $(this).toggleClass("active");
  });
});  


// WEBPACK FOOTER //
// ./source/assets/js/modules/accordion.js